(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.zwcInit) return;
    root.dataset.zwcInit = '1';

    var grid = root.querySelector('[data-zwc-grid]');
    var gridWrap = root.querySelector('[data-zwc-grid-wrap]');
    var filterForm = root.querySelector('[data-zwc-filter-form]');
    var sidebar = root.querySelector('[data-zwc-sidebar]');
    var overlay = root.querySelector('[data-zwc-overlay]');

    /* ---------- STICKY HEADER OFFSET (auto-detect) ---------- */
    function findStickyHeader() {
      var candidates = document.querySelectorAll('header, .header, .site-header, [class*="header"], .shopify-section-header, sticky-header, #shopify-section-header');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.closest('[data-zwc-root]')) continue;
        var pos = getComputedStyle(el).position;
        if ((pos === 'sticky' || pos === 'fixed') && el.offsetHeight > 0) {
          return el;
        }
      }
      return null;
    }
    function syncStickyOffset() {
      if (root.getAttribute('data-sticky-auto') !== 'true') return;
      var header = findStickyHeader();
      var h = header ? header.offsetHeight : 0;
      root.style.setProperty('--zwc-sticky-top', h + 'px');
    }

    syncStickyOffset();
    window.addEventListener('resize', syncStickyOffset);
    window.addEventListener('load', syncStickyOffset);
    setTimeout(syncStickyOffset, 400);
    setTimeout(syncStickyOffset, 1200);

    function formatMoney(amount, fmt) {
      var n = Math.round(amount);
      var s = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (fmt && fmt.indexOf('{{') !== -1) {
        return fmt.replace(/\{\{\s*[a-z_]+\s*\}\}/i, s);
      }
      return '₹' + s;
    }

    /* ---------- SECTION ID (for reliable AJAX section rendering) ---------- */
    function getSectionId() {
      var wrap = root.closest('.shopify-section');
      if (wrap && wrap.id && wrap.id.indexOf('shopify-section-') === 0) {
        return wrap.id.replace('shopify-section-', '');
      }
      return root.getAttribute('data-section-id') || null;
    }

    /* ---------- COLLECTION HANDLE / URL ---------- */
    function getCollectionHandle() {
      var h = root.getAttribute('data-collection-handle');
      if (h) return h;
      var m = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
      return m ? m[1] : null;
    }

    /* ---------- TRUE COLLECTION MIN/MAX (all pages, via products.json) ---------- */
    function fetchCollectionMinMax(handle, cb) {
      if (!handle) { cb(null); return; }
      var minP = null, maxP = null;
      var page = 1;
      var LIMIT = 250;

      function loadPage() {
        var url = '/collections/' + handle + '/products.json?limit=' + LIMIT + '&page=' + page;
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || !data.products || data.products.length === 0) {
              cb((minP != null && maxP != null) ? { min: minP, max: maxP } : null);
              return;
            }
            data.products.forEach(function (prod) {
              (prod.variants || []).forEach(function (v) {
                var price = parseFloat(v.price);
                if (isNaN(price)) return;
                if (minP == null || price < minP) minP = price;
                if (maxP == null || price > maxP) maxP = price;
              });
            });
            if (data.products.length < LIMIT) {
              cb((minP != null && maxP != null) ? { min: minP, max: maxP } : null);
            } else {
              page += 1;
              if (page > 20) {
                cb((minP != null && maxP != null) ? { min: minP, max: maxP } : null);
                return;
              }
              loadPage();
            }
          })
          .catch(function () {
            cb((minP != null && maxP != null) ? { min: minP, max: maxP } : null);
          });
      }
      loadPage();
    }

    function applyTrueRange(range, bounds) {
      if (!range || !bounds) return;
      var minInput = range.querySelector('[data-zwc-range-min]');
      var maxInput = range.querySelector('[data-zwc-range-max]');
      if (!minInput || !maxInput) return;

      var trueMin = Math.floor(bounds.min);
      var trueMax = Math.ceil(bounds.max);
      if (trueMax <= trueMin) return;

      var oldMin = parseFloat(range.dataset.min);
      var oldMax = parseFloat(range.dataset.max);
      var atFloor = parseFloat(minInput.value) <= oldMin + 0.5;
      var atCeil = parseFloat(maxInput.value) >= oldMax - 0.5;

      range.dataset.min = trueMin;
      range.dataset.max = trueMax;
      minInput.min = trueMin; minInput.max = trueMax;
      maxInput.min = trueMin; maxInput.max = trueMax;

      if (atFloor) minInput.value = trueMin;
      if (atCeil) maxInput.value = trueMax;

      if (parseFloat(minInput.value) < trueMin) minInput.value = trueMin;
      if (parseFloat(maxInput.value) > trueMax) maxInput.value = trueMax;

      minInput.dispatchEvent(new Event('input', { bubbles: false }));
    }

    var zwcBoundsCache = null;

    function applyBoundsToAllRanges() {
      if (!zwcBoundsCache) return;
      root.querySelectorAll('[data-zwc-range]').forEach(function (range) {
        applyTrueRange(range, zwcBoundsCache);
      });
    }

    function loadAndApplyTrueMinMax() {
      var handle = getCollectionHandle();
      if (!handle) return;
      if (zwcBoundsCache) { applyBoundsToAllRanges(); return; }
      fetchCollectionMinMax(handle, function (bounds) {
        if (!bounds) return;
        zwcBoundsCache = bounds;
        applyBoundsToAllRanges();
      });
    }

    /* ---------- COLLAPSIBLE SECTIONS ---------- */
    function bindCollapsibles() {
      root.querySelectorAll('[data-zwc-collapse]').forEach(function (section) {
        var content = section.querySelector('.zwc-section-content');
        var toggle = section.querySelector('[data-zwc-collapse-toggle]');
        if (content) content.style.maxHeight = content.scrollHeight + 40 + 'px';
        if (toggle && !toggle.dataset.zwcCollapseBound) {
          toggle.dataset.zwcCollapseBound = '1';
          toggle.addEventListener('click', function (e) {
            if (e.target.closest('[data-zwc-stop]')) return;
            section.classList.toggle('is-collapsed');
            if (!section.classList.contains('is-collapsed') && content) {
              content.style.maxHeight = content.scrollHeight + 40 + 'px';
            }
          });
        }
      });
    }
    bindCollapsibles();

    /* ---------- MOBILE FILTER DRAWER (close side) ---------- */
    var closeBtn = root.querySelector('[data-zwc-close]');
    function closeDrawer() { if (sidebar) sidebar.classList.remove('is-open'); if (overlay) overlay.hidden = true; document.body.style.overflow = ''; }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    /* ---------- PRICE RANGE ---------- */
    function bindRange(range) {
      if (range.dataset.zwcBound) return;
      range.dataset.zwcBound = '1';
      var minInput = range.querySelector('[data-zwc-range-min]');
      var maxInput = range.querySelector('[data-zwc-range-max]');
      var fill = range.querySelector('[data-zwc-range-fill]');
      var minField = range.parentElement.querySelector('[data-zwc-price-min-field]');
      var maxField = range.parentElement.querySelector('[data-zwc-price-max-field]');
      var display = range.parentElement.querySelector('[data-zwc-price-display]');
      var fmt = range.getAttribute('data-money-format') || '';
      function bounds() { return { lo: parseFloat(range.dataset.min), hi: parseFloat(range.dataset.max) }; }
      function paint() {
        var b = bounds(), lo = b.lo, hi = b.hi;
        var a = parseFloat(minInput.value), bb = parseFloat(maxInput.value);
        if (a > bb - 1) { a = bb - 1; minInput.value = a; }
        var l = ((a - lo) / (hi - lo)) * 100, r = ((bb - lo) / (hi - lo)) * 100;
        if (fill) { fill.style.left = l + '%'; fill.style.right = (100 - r) + '%'; }
        if (display) { display.textContent = formatMoney(a, fmt) + ' – ' + formatMoney(bb, fmt); }
        if (minField) minField.value = (a > lo) ? Math.round(a) : '';
        if (maxField) maxField.value = (bb < hi) ? Math.round(bb) : '';
      }
      function commit() { paint(); submitFilters(); }
      [minInput, maxInput].forEach(function (inp) {
        inp.addEventListener('input', paint);
        inp.addEventListener('change', commit);
      });
      paint();
    }
    root.querySelectorAll('[data-zwc-range]').forEach(bindRange);

    loadAndApplyTrueMinMax();

    /* ---------- AUTO-SUBMIT ON FILTER CHANGE + BLOCK NATIVE SUBMIT ---------- */
    function bindFilterInputs() {
      if (!filterForm) return;
      if (!filterForm.dataset.zwcSubmitBound) {
        filterForm.dataset.zwcSubmitBound = '1';
        filterForm.addEventListener('submit', function (e) {
          e.preventDefault();
          submitFilters();
        });
      }
      filterForm.querySelectorAll('[data-zwc-auto]').forEach(function (input) {
        if (input.type === 'hidden') return;
        if (input.dataset.zwcAutoBound) return;
        input.dataset.zwcAutoBound = '1';
        input.addEventListener('change', submitFilters);
      });
    }
    bindFilterInputs();

    /* ---------- IN-STOCK DEFAULT ON ----------
       The availability toggle is only `checked` when the URL already
       carries the filter param, so on a fresh load it starts OFF.
       Here we turn it ON by default and apply it. If the user turns
       it OFF themselves, we remember that for the session and stop
       forcing it back on. Enforcement runs ONCE per page load only,
       so removing the pill / unchecking never fights the script. */
    var STOCK_OFF_KEY = 'zwcStockOff';

    function getStockToggle() {
      return filterForm ? filterForm.querySelector('.zwc-instock-section input[type="checkbox"]') : null;
    }

    function bindStockToggle() {
      var toggle = getStockToggle();
      if (!toggle || toggle.dataset.zwcStockBound) return;
      toggle.dataset.zwcStockBound = '1';
      toggle.addEventListener('change', function () {
        try {
          if (toggle.checked) sessionStorage.removeItem(STOCK_OFF_KEY);
          else sessionStorage.setItem(STOCK_OFF_KEY, '1');
        } catch (err) { /* storage unavailable — default stays on each load */ }
      });
    }
    bindStockToggle();

    function enforceStockDefault() {
      var toggle = getStockToggle();
      if (!toggle || toggle.checked) return;
      var userOff = false;
      try { userOff = sessionStorage.getItem(STOCK_OFF_KEY) === '1'; } catch (err) {}
      if (userOff) return;
      toggle.checked = true;
      submitFilters();
    }

    /* ---------- CLEAR ALL + ACTIVE-FILTER PILL REMOVE (AJAX, no reload) ---------- */
    // One delegated handler on root (capture phase) covers:
    //   • [data-zwc-clear]  → Clear All / Clear (bare collection URL)
    //   • .zwc-active-pill  → the × on an active-filter pill (removes one filter via its href)
    // Delegation means it survives sidebar innerHTML swaps.
    if (!root.dataset.zwcClearBound) {
      root.dataset.zwcClearBound = '1';
      root.addEventListener('click', function (e) {
        // 1) Clear All / Clear
        var clearEl = e.target.closest('[data-zwc-clear]');
        if (clearEl && root.contains(clearEl)) {
          e.preventDefault();
          e.stopPropagation();
          var chref = clearEl.getAttribute('href') || window.location.pathname;
          // Preserve the current sort when clearing filters
          var sortVal = getCurrentSort();
          var clearBase = chref.split('?')[0];
          var clearQs = sortVal ? 'sort_by=' + encodeURIComponent(sortVal) : '';
          navigate(clearBase + (clearQs ? '?' + clearQs : ''), clearQs);
          return;
        }
        // 2) Active-filter pill × (remove a single filter)
        var pill = e.target.closest('.zwc-active-pill');
        if (pill && root.contains(pill)) {
          // Occasion/tag pills are client-side — zwc-occasion-filter.js owns them
          if (pill.hasAttribute('data-zwc-client-pill')) return;
          e.preventDefault();
          e.stopPropagation();
          var phref = pill.getAttribute('href');
          if (!phref) return;
          // href is like /collections/x?filter... (already the "one filter removed" URL)
          var parts = phref.split('?');
          var qs = parts.length > 1 ? parts[1] : '';
          navigate(phref, qs);
          return;
        }
      }, true); // capture phase — beats the anchor's default navigation
    }

    /* ---------- CURRENT SORT (single source of truth = the live URL) ---------- */
    function getCurrentSort() {
      var url = new URL(window.location.href);
      var s = url.searchParams.get('sort_by');
      if (s) return s;
      // Fallback: read the hidden sort field in the filter form
      var hidden = filterForm ? filterForm.querySelector('input[name="sort_by"]') : null;
      return hidden ? hidden.value : '';
    }

    function submitFilters() {
      if (!filterForm) return;
      // Keep the hidden sort_by field in the form in sync with the live URL,
      // so filters always carry the current sort even after a sort change.
      var hidden = filterForm.querySelector('input[name="sort_by"]');
      var liveSort = new URL(window.location.href).searchParams.get('sort_by');
      if (hidden && liveSort) hidden.value = liveSort;

      var fd = new FormData(filterForm);
      var params = new URLSearchParams();
      fd.forEach(function (val, key) {
        if (val !== '' && val != null) params.append(key, val);
      });
      var qs = params.toString();
      var base = window.location.pathname;
      navigate(base + (qs ? '?' + qs : ''), qs);
    }

    /* ---------- AJAX NAVIGATE ---------- */
    function navigate(displayUrl, qs) {
      if (gridWrap) gridWrap.classList.add('is-loading');

      var sectionId = getSectionId();
      var basePath = displayUrl.split('?')[0];
      var fetchUrl;
      if (sectionId) {
        var sep = (qs && qs.length) ? '&' : '';
        fetchUrl = basePath + '?' + (qs || '') + sep + 'section_id=' + encodeURIComponent(sectionId);
      } else {
        fetchUrl = displayUrl;
      }

      fetch(fetchUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newRoot = doc.querySelector('[data-zwc-root]');

          if (!newRoot && sectionId) {
            fetch(displayUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(function (r2) { return r2.text(); })
              .then(function (html2) {
                var doc2 = new DOMParser().parseFromString(html2, 'text/html');
                var newRoot2 = doc2.querySelector('[data-zwc-root]');
                if (!newRoot2) { window.location.href = displayUrl; return; }
                swapIn(newRoot2, displayUrl);
              })
              .catch(function () { window.location.href = displayUrl; });
            return;
          }

          if (!newRoot) { window.location.href = displayUrl; return; }
          swapIn(newRoot, displayUrl);
        })
        .catch(function () { window.location.href = displayUrl; });
    }

    function swapIn(newRoot, displayUrl) {
      var newSidebar = newRoot.querySelector('[data-zwc-sidebar]');
      var newGridWrap = newRoot.querySelector('[data-zwc-grid-wrap]');
      var newSortDropdown = newRoot.querySelector('[data-zwc-sort-dropdown]');
      var newSortTriggerText = newRoot.querySelector('[data-zwc-sort-trigger-text]');
      if (newSidebar && sidebar) sidebar.innerHTML = newSidebar.innerHTML;
      if (newGridWrap && gridWrap) gridWrap.innerHTML = newGridWrap.innerHTML;
      var currentSortDropdown = root.querySelector('[data-zwc-sort-dropdown]');
      if (newSortDropdown && currentSortDropdown) {
        currentSortDropdown.innerHTML = newSortDropdown.innerHTML;
      }
      window.history.pushState({}, '', displayUrl);
      if (gridWrap) gridWrap.classList.remove('is-loading');
      reinit();
      document.dispatchEvent(new CustomEvent('zwc:rerender', { bubbles: true }));
      syncStickyOffset();
    }

    function reinit() {
      grid = root.querySelector('[data-zwc-grid]');
      filterForm = root.querySelector('[data-zwc-filter-form]');
      bindCollapsibles();
      bindFilterInputs();
      bindStockToggle();
      root.querySelectorAll('[data-zwc-range]').forEach(bindRange);
      applyBoundsToAllRanges();
    }

    /* ---------- SHARED NAVIGATE HANDSHAKE ----------
       Expose navigate() so the toolbar (sort) can route through the SAME
       AJAX pipeline instead of running its own fetch. This is what makes
       sort + filters compose: one pipeline, one re-bind, one URL. */
    root._zwcNavigate = navigate;
    root._zwcGetCurrentSort = getCurrentSort;

    if (!root.dataset.zwcSortBound) {
      root.dataset.zwcSortBound = '1';
      // Toolbar dispatches this with { detail: { sort: 'best-selling' } }
      root.addEventListener('zwc:sort', function (e) {
        var sortVal = e.detail && e.detail.sort;
        if (!sortVal) return;
        var url = new URL(window.location.href);   // live URL = current filters
        url.searchParams.set('sort_by', sortVal);  // layer new sort on top
        url.searchParams.delete('page');
        var qs = url.searchParams.toString();
        navigate(url.pathname + (qs ? '?' + qs : ''), qs);
      });
    }

    window.addEventListener('popstate', function () { window.location.reload(); });

    /* Apply the in-stock default ONCE per page load (after everything is bound) */
    enforceStockDefault();
  }

  function boot() {
    document.querySelectorAll('[data-zwc-root]').forEach(initRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();